import { z } from "zod";
//#region src/cp-services-health.ts
/**
* The CP service health summary: `GET /v1/admin/cp-services/health` (site-admin-api
* `CpHealthController.getHealth`, gate `cp:platform:read`).
*
* Plan `2026-10-21-operator-tui`, defaults row F1. Producer: site-admin-api
* `CpHealthService.getHealth`, the types `CpServiceHealthResponse` and `CpServiceHealth`. The
* service reads each value from Mimir, and a value Mimir has no series for is `null`, never `0`.
*/
/** A health verdict. `unknown` means the CP could not measure the service. */
const CP_SERVICE_HEALTH_STATUSES = [
	"healthy",
	"degraded",
	"down",
	"unknown"
];
/**
* One CP service. `name` is the service name (`platform-api`), `displayName` the console text.
* `requestRate`, `errorRate`, `p95Latency`, `uptimePercent` and each pod count are `null` when
* Mimir had no series.
*/
const cpServiceHealthSchema = z.object({
	name: z.string().min(1),
	displayName: z.string().min(1),
	status: z.enum(CP_SERVICE_HEALTH_STATUSES),
	requestRate: z.number().nullable(),
	errorRate: z.number().nullable(),
	p95Latency: z.number().nullable(),
	podCount: z.object({
		running: z.number().int().nonnegative().nullable(),
		desired: z.number().int().nonnegative().nullable()
	}).strict(),
	uptimePercent: z.number().nullable()
}).strict();
/** The summary: one entry per CP service, and the ISO-8601 time of the read. */
const cpServicesHealthResponseSchema = z.object({
	services: z.array(cpServiceHealthSchema),
	timestamp: z.iso.datetime()
}).strict();
//#endregion
export { CP_SERVICE_HEALTH_STATUSES, cpServiceHealthSchema, cpServicesHealthResponseSchema };

//# sourceMappingURL=cp-services-health.js.map